import { SelectOption, SelectOptionGroup } from "../interfaces/SelectOption"
import { useEffect, useState } from "react"
import { useMerchantStore } from "../stores/MerchantStore"
import { useParams } from "react-router-dom";
import useSWR from "swr";
import useUser from "./User";
import axios from "axios";
import useAccessToken from "./AccessToken";
import { useMeetingStore } from "../stores/MeetingsStore";

const API_URL = process.env.REACT_APP_API_URL

const useGroupMerchantMeeting = () => {
    const [merchantData, setMerchantData] = useState<SelectOptionGroup[]>([]);
    const { multiMerchants, merchants, setMerchantLoading, setMerchants } = useMerchantStore()
    const { selectMultiMeeting } = useMeetingStore()
    const { templateMeetingId } = useParams()
    const user = useUser()
    const token = useAccessToken()

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const { data: merchantsData = [], error: merchantsError, isLoading: merchantsLoading } = useSWR(user.data.permission_merchant_read !== 'NONE' ? `${API_URL}merchants${templateMeetingId ? `?meetingTemplateId=` + templateMeetingId : ""}` : null, fetcher)

    useEffect(() => {
        setMerchantLoading(merchantsLoading)
        if (!merchantsLoading) {
            setMerchants(merchantsData)
        }
    }, [merchantsLoading]);


    useEffect(() => {
        const groupMerchant: { label: string, id: string, options: SelectOption[] }[] = multiMerchants.map((group) => {
            return {
                label: group.name,
                id: group.id,
                options: [] as SelectOption[]
            }
        })

        setMerchantLoading(merchantsLoading)

        if (!merchantsLoading && merchants.length > 0) {
            if (Object.keys(selectMultiMeeting).length > 0 && selectMultiMeeting?.merchantTemplates.length === 0) {
                merchants.forEach((merchant: any) => {
                    const index = groupMerchant.findIndex((group) => group.id === merchant.merchantTemplateId)
                    index !== -1 && groupMerchant[index].options.push({
                        value: merchant.id,
                        label: merchant.name + " / " + merchant.phone
                    })
                })
            } else {
                const filteredMerchants = merchants.filter((merchant: any) => selectMultiMeeting?.merchantTemplates?.some((merchantTemplate) => merchantTemplate.id === merchant.merchantTemplateId))
                filteredMerchants.forEach((merchant: any) => {
                    const index = groupMerchant.findIndex((group) => group.id === merchant.merchantTemplateId)
                    index !== -1 && groupMerchant[index].options.push({
                        value: merchant.id,
                        label: merchant.name + " / " + merchant.phone
                    })
                })
            }

            setMerchantData(groupMerchant)
        }
    }, [templateMeetingId, selectMultiMeeting, multiMerchants, merchants])

    return {
        merchantData,
        merchantsLoading,
        merchantsData
    }
}

export default useGroupMerchantMeeting;